import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-massachusetts-review-four',
  templateUrl: './massachusetts-review-four.component.html',
  styleUrls: ['./massachusetts-review-four.component.scss']
})
export class MassachusettsReviewFourComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
